<template>
  <div id="contenedor-entidades-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevaEntidad="registrarNuevaEntidad"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoEntidades="getEntidaded"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaEntidad"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <registrar-nueva-entidad
        v-if="mostrarVentanaRegistrarNuevaEntidad"
        v-on:cerrar="cerrarRegistrarNuevaEntidad">
      </registrar-nueva-entidad>
    </v-dialog>
    <v-dialog
    v-if="estaEntidad"
      v-model="mostrarVentanaEditarEntidad"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <editar-entidad
      :entidadEditar="estaEntidad"
        v-on:cerrar="cerrarEditarEntidad">
      </editar-entidad>
    </v-dialog>
    <v-dialog
    v-if="estaEntidad"
      v-model="mostrarVentanaEliminarEntidad"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-entidad
      :entidadEliminar="estaEntidad"
        v-on:cerrar="cerrarRemoverEntidad">
      </eliminar-entidad>
    </v-dialog>
  </div>
</template>

<script>
import ENTIDADES from '@/graphql/querys/administracion/catalogos/entidades/entidades.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevaEntidad from '@/components/administracion/configuracion/catalogos/entidades/Nuevo.vue';
import EditarEntidad from '@/components/administracion/configuracion/catalogos/entidades/Editar.vue';
import EliminarEntidad from '@/components/administracion/configuracion/catalogos/entidades/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'EntidadesDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaEntidad,
    EditarEntidad,
    EliminarEntidad,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaEntidad: false,
      mostrarVentanaEditarEntidad: false,
      mostrarVentanaEliminarEntidad: false,
      estaEntidad: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    entidades: {
      query: ENTIDADES,
    },
  },
  mounted() {
    eventBus.$on('editar-entidad', (entidad) => {
      this.estaEntidad = entidad;
      this.mostrarVentanaEditarEntidad = true;
    });
    eventBus.$on('eliminar-entidad', (entidad) => {
      this.estaEntidad = entidad;
      this.mostrarVentanaEliminarEntidad = true;
    });
  },
  methods: {
    registrarNuevaEntidad() {
      this.mostrarVentanaRegistrarNuevaEntidad = true;
    },
    cerrarRegistrarNuevaEntidad() {
      this.mostrarVentanaRegistrarNuevaEntidad = false;
    },
    cerrarEditarEntidad() {
      this.mostrarVentanaEditarEntidad = false;
      this.estaEntidad = null;
    },
    cerrarRemoverEntidad() {
      this.mostrarVentanaEliminarEntidad = false;
      this.estaEntidad = null;
    },
  },
  computed: {
    getEntidaded() {
      if (!this.entidades) return [];
      return this.entidades
      // Filtrar por Texto de Busqueda
        .filter((entidad) => {
          if (!this.filtros.buscarTexto) return entidad;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(entidad.nombre);
          const nombreCorto = this.$normalizacionTexto(entidad.nombreCorto);
          return (
            expt.test(nombre)
            || expt.test(nombreCorto)
            || expt.test(entidad.nombre)
            || expt.test(entidad.nombreCorto)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
